import { useCallback, useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import { Navigation } from "lucide-react";
import { API } from "@/lib/api";
import { LocMap, OpenInMaps } from "@/components/location/LocMap";

const left = (iso, now) => {
  const m = Math.round((new Date(iso) - now) / 60000);
  return m > 0 ? `in ${m} min` : m === 0 ? "any minute now" : `${-m} min late`;
};

export default function EtaPublic() {
  const { token } = useParams();
  const [d, setD] = useState(null);
  const [gone, setGone] = useState(false);
  const [now, setNow] = useState(new Date());
  const load = useCallback(() => axios.get(`${API}/eta/${token}`).then(({ data }) => setD(data)).catch(() => setGone(true)), [token]);
  useEffect(() => { load(); const a = setInterval(load, 30000); const b = setInterval(() => setNow(new Date()), 15000); return () => { clearInterval(a); clearInterval(b); }; }, [load]);
  return (
    <div className="min-h-screen bg-q-bg px-4 py-10 text-q-text" data-testid="eta-public-page">
      <div className="mx-auto max-w-md space-y-4">
        <p className="flex items-center gap-2 text-xs font-black uppercase tracking-[0.2em] text-q-faint"><Navigation className="h-4 w-4" /> ETA</p>
        {gone ? <p className="text-lg font-semibold" data-testid="eta-public-notfound">This ETA link isn't valid.</p> : !d ? <p className="text-q-muted">Loading…</p> : d.state !== "active" ? (
          <p className="font-display text-3xl font-extrabold" data-testid="eta-public-message">{d.message}</p>
        ) : (
          <>
            <h1 className="font-display text-4xl font-extrabold" data-testid="eta-public-title">{d.name} is on the way to {d.destination} {d.dest_emoji}</h1>
            <p className="text-lg" data-testid="eta-public-countdown">Arriving {left(d.arrive_at, now)} · {new Date(d.arrive_at).toLocaleTimeString([], { hour: "numeric", minute: "2-digit" })}</p>
            {d.location ? <>
              <LocMap lat={d.location.lat} lng={d.location.lng} height={260} testid="eta-public-map" />
              <p className="text-sm text-q-muted" data-testid="eta-public-loc-time">Last shared location: {new Date(d.location.at).toLocaleTimeString([], { hour: "numeric", minute: "2-digit" })}</p>
              <OpenInMaps lat={d.location.lat} lng={d.location.lng} label={d.name} testid="eta-public-open-maps" />
            </> : <p className="text-sm text-q-muted" data-testid="eta-public-noloc">No location shared.</p>}
          </>
        )}
      </div>
    </div>
  );
}
